import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'db-account-deleted',
    templateUrl: './account-deleted.component.html',
    styleUrls: ['./account-deleted.component.scss'],
    standalone: false
})
export class AccountDeletedComponent implements OnInit {

  constructor(private _router: Router) {}

  ngOnInit() {
  }

  navigateToLogin(){
    this._router.navigateByUrl('/login');
  }
}
